import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "react-moment";
import Axios from "axios";
import AsignMarkTest from "../component/AssignMarkTest";
import UserDropDown from "../component/UserDropDown";
import { URL_LIST_ALL } from "../configs/Api";
import AkkhorLayout from "../layout/Akkhor";
import SRList from "../component/List";

export default function ListTestsRacing(props) {
  const { disableAction } = props;
  const type = 1
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const { user } = useSelector((state) => state.auth);
  const localgrade_id = user && user.data && user.data.class && user.data.class.grade_id > 0 ? user.data.class.grade_id : 0;
  const localclass_id = user && user.data && user.data.class && user.data.class.class_id > 0 ? user.data.class.class_id : 0;
  const [params, setParam] = useState('&type=1');
  const [keyword, setKeyword] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [grade_id, setGrade_id] = useState(localgrade_id > 0 ? localgrade_id : 'all');
  const [class_id, setClass_id] = useState(localclass_id > 0 ? localclass_id : 'all');
  const [type_id, setType_id] = useState('all');
  const [teachers, setTeachers] = useState([]);
 

  const handleCallback = (start, end, label) => {
    setStartDate(start)
    setEndDate(end)
  }

  const createParam = () => {
    let _param =  '&type=' + type
    if (grade_id > 0) _param += "&grade_id=" + grade_id
    if (class_id > 0) _param += "&class_id=" + class_id
    if (type_id > 0) _param += "&type_id=" + type_id
    if (keyword !== '') _param += "&key=" + keyword
    if (startDate > 0 && endDate > 0) _param += "&daterange=" + startDate.format('YYYY-MM-DD') + "_" + endDate.format('YYYY-MM-DD')
    setParam(_param);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    createParam();
  };

  useEffect(() => {
    createParam();
    let mounted = true;
    let config ={
      headers: {
        'Authorization': 'Bearer ' + user.access_token,
        'asselect': JSON.stringify(["users.id as value","users.fullname as name"])
      }
    }
    Axios.get(URL_LIST_ALL + "users?page=1&limit=500&typeaccount=1", config).then((res) => {
      if (res.data && res.data.status === "success") {
        if (mounted){
          let localList=[]
          localList = localList.concat(res.data.data)
          setTeachers(localList);
        }
    } else console.log(res.data.message);
  }).catch((err) => { console.log(err) });

  }, [user]);// eslint-disable-line

  let columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "title", label: "Tên", options: { filter: true, sort: true } },
    { name: "fullname", label: "Người tạo", options: { filter: true, sort: true } },
    { name: "khoahoc_title", label: "Khóa học", options: { filter: true, sort: true } },

    {
      name: "datecreate", label: "Ngày đăng", options: {
        filter: false, sort: true,
        customBodyRender: (value) => {
          const time = new Date(value * 1000);
          return <Moment format="HH:mm DD/MM/YYYY">{time}</Moment>;
        },
      },
    }
  ];

  columns.push({
    name: "id", label: "Xem trước", options: {
      filter: false, sort: true,
      customBodyRender: (value) => {
        return <Link to={"/examination-detail/" + value} className="btn btn-sm btn-info" >{type === 1 ? "Xem trước" : "Xem trước"}</Link>;
      }
    }
  })
  //xem báo cáo chi tiết một bài kiểm tra
  columns.push({
    name: "id", label: "Thống kê", options: {
      filter: false, sort: true,
      customBodyRender: (value) => {
        return <Link to={"/racing-report/" + value} className="btn btn-sm btn-success" >Báo cáo</Link>;
      }
    }
  })


  return (
    <AkkhorLayout idrole="list-tomo-racing" roleignone={user.data.typeaccount === 2}>
      <SRList name="at_exam_tests" idrole="list-tomo-racing" linkaction={'racing'} params={params} title={ "Danh sách bài thi Đường đua Tomo"} defaultLimit={50} serverSide={true} onlyList={true} columns={columns}>
        <div className="card pb-0 height-auto mb-3 mt-5">
          <div className="card-body">
            <div className="d-flex pb-2">
              <div className="mr-auto">
                <h3>Tìm kiếm</h3>
              </div>
              {!disableAction && <div className="p-2">
                <Link to={"/add-tomo-racing"}>
                  <button className="btn btn-success">{"Tạo bài thi Tomo Racing"}</button>
                </Link>
              </div>}
            </div>
            <form className="new-added-form" method="get" >
              <div className="row">
                <div className="col-lg-3 col-sm-6 col-12 form-group">
                  <label>Từ khoá </label>
                  <input type="text" placeholder="Tìm theo từ khoá" value={keyword} onChange={(e) => setKeyword(e.target.value)} className="form-control height32" autoComplete="off" />
                </div>
                <div className="col-lg-3 col-sm-6 col-12 form-group">
                  <label>Khóa </label>
                  <UserDropDown apiname={"grades?orderby=title-ASC"} placeholder="Chọn khối" colvalue={"grades.id"} colname={"grades.title"} name="grade_id" defaultValue={grade_id}
                    onChange={async (e) => { setGrade_id(e) }} all={true} disabled={user.data.typeaccount === 2}
                  ></UserDropDown>
                </div>
                <div className="col-lg-3 col-sm-6 col-12 form-group">
                  <label>Lớp </label>
                  <UserDropDown apiname={"class?key=&page=1&orderby=title-ASC&limit=500&grade_id=" + grade_id} placeholder="Tất cả lớp" defaultValue={class_id} colvalue={'class.id'} colname={'class.title'} name='class_id'
                    onChange={async (e) => { setClass_id(e); }} all={true} disabled={user.data.typeaccount === 2}
                  ></UserDropDown>
                </div>
               
                <div className="col-lg-3 col-sm-6 col-12 form-group">
                  <label>Phân loại </label>
                  <UserDropDown apiname={"exam_param?page=1&orderby=title-ASC&limit=500&idtype=1"} placeholder="Chọn loại" colvalue={"exam_param.id"} defaultValue={type_id} colname={"exam_param.title"} name='type_id'
                    onChange={async (e) => { setType_id(e) }} all={true}></UserDropDown>
                </div>
                <div className="col-sm-6 col-12 form-group">
                  <label> Thời gian </label>
                  <DateRangePicker initialSettings={{ startDate: startDate, endDate: endDate, maxDate: "" }}
                    onCallback={handleCallback}
                  >
                    <div className='d-flex align-items-center'>
                      <span style={{ whiteSpace: 'nowrap' }} className="mr-2">Từ ngày</span>
                      <input
                        className="form-control h-31 form-control-sm"
                        placeholder='Từ ngày'
                        readOnly={true}
                        onChange={(e) => setStartDate(e)}
                        value={startDate > 0 ? startDate.format('YYYY-MM-DD') : ""}
                      />
                      <span className='fas fa-arrow-right mx-4' />
                      <span style={{ whiteSpace: 'nowrap' }} className="mr-2">Đến ngày</span>
                      <input
                        className="form-control h-31 form-control-sm"
                        placeholder='Đến ngày'
                        readOnly={true}
                        onChange={(e) => setEndDate(e)}
                        value={endDate > 0 ? endDate.format('YYYY-MM-DD') : ""}
                      />
                    </div>
                  </DateRangePicker>
                </div>
                <div className="col-12 ">
                  <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </SRList>
    </AkkhorLayout>
  );
}
